export class PipeInvertUtility {
  static ftDivider = 12

  constructor(inches) {
    this.inches = inches
  }

  get ft() {
    return this.inches / PipeInvertUtility.ftDivider
  }
}

export default class PipeInvert {
  static TYPE = {
    _M: {
      identifier:null,
      tConnections: 3,
      imgType: 'PIPE_INVERT',
      od: new PipeInvertUtility(30),
      width: new PipeInvertUtility(30),
      length: new PipeInvertUtility(30),
      description: '36" X 90" Demo',
    },
    _3698AN: {
      tConnections: 3,
      imgType: 'PIPE_INVERT',
      od: new PipeInvertUtility(30),
      width: new PipeInvertUtility(52.3),
      length: new PipeInvertUtility(52.3),
      description: '36" X 90" Demo',
    },
  }
}



// WEBPACK FOOTER //
// ./src/lib/Pipes/PipeAccessories/pipe-invert.js